import { Pipe, PipeTransform } from '@angular/core';
import { isString } from 'src/lib/utilities/compare';
import { formatTemporal } from 'src/lib/utilities/temporal-format';

@Pipe({
	name: 'temporalFormat',
})
export class TemporalFormatPipe implements PipeTransform {
	transform(value: Temporal.ZonedDateTime, format: string): string {
		if (!isString(format)) {
			throw Error(`No format given for TemporalFormatPipe`);
		}

		if (value == null) return '';
		else {
			return formatTemporal(value, format);
		}
	}
}
